import { useQuery } from '@tanstack/react-query';

// common
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceOtherDocumentDetails } from 'modules/suppliers/types';

// export type OtherDocumentDetails = typeof schemas.DocumentDetailFromKios._type;
export type OtherDocumentDetails = ReplaceOtherDocumentDetails;

interface UseOtherDocumentsDetailsProps {
  customerOperationCode?: string;
  supplierProfileOperationCode?: string;
  documentOperationCode?: string;
}

const useOtherDocumentsDetails = (props: UseOtherDocumentsDetailsProps) => {
  const { customerOperationCode, supplierProfileOperationCode, documentOperationCode } = props;

  const service = useService();

  return useQuery({
    queryKey: ['otherDocumentsDetails'],
    queryFn: async () => {
      try {
        if (
          !service ||
          !customerOperationCode ||
          !supplierProfileOperationCode ||
          !documentOperationCode
        ) {
          return null;
        }

        const res: OtherDocumentDetails = await service.SupplierProfileController_getDocumentDetail(
          {
            params: {
              customerOperationCode,
              supplierProfileOperationCode,
              documentOperationCode,
            },
          }
        );

        return res;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useOtherDocumentsDetails;
